module.exports = __webpack_public_path__ + "static/media/ic_flight.16a909a1.png";